import { getAuthToken } from '../utils/auth';
import { handleUnauthorized } from '../utils/errorHandler';

const API_BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL;

export interface PlayerInfo {
  dataType: string;
  playerName: string;
  position: string;
  height: string;
  weight: string;
  team: string;
  birthDate: string;
  college: string;
  highSchool: string;
  draftInfo: string;
  instagram?: string;
  headshotUrl?: string;
  footballReferenceUrl?: string;
}

export interface PlayerSeasonStats {
  dataType: string;
  playerName: string;
  position: string;
  season: number;
  team: string;
  gamesPlayed: number;
  gamesStarted: number;
  [key: string]: any; // For dynamic stats
}

export interface PlayerProjections {
  dataType: string;
  source: string;
  season: number;
  playerName: string;
  team: string;
  position: string;
  games: number;
  fantasyPoints: number;
  [key: string]: any; // For dynamic projections
}

export interface Transaction {
  dataType: string;
  team: string;
  playerName: string;
  date: string;
  description: string;
}

export interface PlayerDetailResponse {
  playerDetail: {
    playerInfo: PlayerInfo;
    playerSeasonStats: PlayerSeasonStats[];
    playerProjections: PlayerProjections;
    transactions: Transaction[];
  };
}

export const fetchPlayerDetail = async (playerName: string): Promise<PlayerDetailResponse['playerDetail']> => {
  const token = getAuthToken();
  
  if (!token) {
    throw new Error('Authentication expired');
  }

  const response = await fetch(`${API_BASE_URL}/players/${encodeURIComponent(playerName)}/detail`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (response.status === 401) {
    handleUnauthorized();
    throw new Error('UNAUTHORIZED');
  }

  if (!response.ok) {
    throw new Error('Failed to fetch player details');
  }

  const data: PlayerDetailResponse = await response.json();
  return data.playerDetail;
};